import * as EditorTypeAll from './tinymce.d';

type EditorType = EditorTypeAll.Editor;

/**
 * 链接对话框处理器
 * 专门处理链接插件的自定义对话框逻辑，不影响其他插件
 */
export class LinkDialogHandler {
  private editor: EditorType;
  private openDialogCallback: ((editor: EditorType) => void) | null = null;

  constructor(editor: EditorType) {
    this.editor = editor;
    this.setupLinkDialogHandler();
  }

  /**
   * 设置打开对话框的回调函数
   */
  setOpenDialogCallback(callback: (editor: EditorType) => void) {
    this.openDialogCallback = callback;
  }

  /**
   * 设置链接对话框处理器
   */
  private setupLinkDialogHandler() {
    // 监听自定义链接对话框事件
    this.editor.on('customLinkDialog', () => {
      if (this.openDialogCallback) {
        this.openDialogCallback(this.editor);
      }
    });

    // 重写mceLink命令，但只在启用自定义对话框时生效
    if (this.editor.getParam('useCustomLinkDialog', false)) {
      this.editor.addCommand('mceLink', () => {
        this.editor.fire('customLinkDialog');
      });
    }
  }

  /**
   * 销毁处理器
   */
  destroy() {
    // 移除事件监听器
    this.editor.off('customLinkDialog');
    this.openDialogCallback = null;
  }
}

/**
 * 为编辑器实例创建链接对话框处理器
 */
export const createLinkDialogHandler = (
  editor: EditorType,
  openDialogCallback: (editor: EditorType) => void
): LinkDialogHandler => {
  const handler = new LinkDialogHandler(editor);
  handler.setOpenDialogCallback(openDialogCallback);
  return handler;
};
